import { Link } from 'react-router-dom';
import { Outlet } from 'react-router-dom';
import Navbar from './Navbar';
import SocialIcons from '../../components/common/Socials/SocialIcons'
import { useState } from 'react';
// import { useStrapiConstants } from '../../hooks/useStrapiConstants';

import { useStrapiConstants } from '../../contexts/StrapiConstantsContext';
import Loading from '../common/Loading';
import './Layout.css';

const Layout = () => {

    return (
        <div className="min-h-screen flex flex-col">
            <Navbar />
            <main className="flex-1">
                <Outlet />
            </main>
            <Footer />
        </div>
    );
};

const Footer = () => {
    const [openSection, setOpenSection] = useState(null);

    const toggleSection = (section) => {
        setOpenSection(openSection === section ? null : section);
    };
    const { loaded, contactPage, directorates, symposium } = useStrapiConstants();

    if (!loaded) return <Loading />
    return (
        <footer className="bg-white text-black mt-auto">
            {/* Desktop Footer */}
            <div className="hidden md:block px-8 py-8">
                <div className="max-w-[1200px] mx-auto">
                    {/* Logo and Social Icons Row */}
                    <div className="flex justify-between items-center pb-12">
                        {/* Logo on the left */}
                        <Link to="/" className="flex items-center shrink-0 py-2">
                            <img
                                src="/esam-logo.png"
                                alt="ESAM Logo"
                                className="h-12 w-auto max-w-[180px] object-contain"
                            />
                        </Link>

                        {/* Social icons on the right */}
                        <div className="flex space-x-4">
                            <SocialIcons />
                        </div>
                    </div>


                    {/* Footer Columns */}
                    <div className="flex justify-between pb-12">
                        {/* Kurumsal */}
                        <div>
                            <div className="text-lg text-[#1e5a96] font-black pb-1">
                                Kurumsal
                            </div>
                            <div className="py-0.5">
                                <Link to="kurumsal/kurumsal-kimlik-rehberi" className="text-black hover:text-[#1e5a96] transition">
                                    Kurumsal Kimlik
                                </Link>
                            </div>
                            <div className="py-0.5">
                                <Link to="kurumsal/misyon-vizyon" className="text-black hover:text-[#1e5a96] transition">
                                    Misyon & Vizyon
                                </Link>
                            </div>
                            <div className="py-0.5">
                                <Link to="kurumsal/baskan" className="text-black hover:text-[#1e5a96] transition">
                                    Başkan
                                </Link>
                            </div>
                            <div className="py-0.5">
                                <Link to="kurumsal/yonetim-kurulu" className="text-black hover:text-[#1e5a96] transition">
                                    Yönetim Kurulu
                                </Link>
                            </div>
                        </div>

                        {/* Basın */}
                        <div>
                            <div className="text-lg text-[#1e5a96] font-black pb-1">
                                Basın
                            </div>
                            <div className="py-0.5">
                                <Link to="basin/haberler" className="text-black hover:text-[#1e5a96] transition">
                                    Duyurular & Haberler
                                </Link>
                            </div>
                            <div className="py-0.5">
                                <Link to="basin/yayinlar" className="text-black hover:text-[#1e5a96] transition">
                                    Yayınlar
                                </Link>
                            </div>
                            <div className="py-0.5">
                                <Link to="basin/dergiler" className="text-black hover:text-[#1e5a96] transition">
                                    Dergiler
                                </Link>
                            </div>
                        </div>

                        {/* Direktörlüklerimiz */}
                        {directorates?.length > 0 && (
                            <div>
                                <div className="text-lg text-[#1e5a96] font-black pb-1">
                                    Direktörlüklerimiz
                                </div>

                                {directorates.slice(0, 6).map((item) => (
                                    <div key={item.documentId} className="py-0.5">
                                        <Link
                                            to={`/direktorlukler/${item.slug}`}
                                            className="text-black hover:text-[#1e5a96] transition"
                                        >
                                            {item.displayTitle}
                                        </Link>
                                    </div>
                                ))}

                                <div className="py-0.5">
                                    <Link
                                        to="/direktorlukler"
                                        className="text-black hover:text-[#1e5a96] transition"
                                    >
                                        Hepsini incele
                                    </Link>
                                </div>
                            </div>
                        )}

                        {/* Bize Ulaşın */}
                        <div>
                            <div className="text-lg text-[#1e5a96] font-black pb-1">
                                Bize Ulaşın
                            </div>
                            <div className="py-0.5">
                                <a href={`tel:${contactPage.number}`} className="text-black hover:text-[#1e5a96] transition">
                                    {contactPage.number}
                                </a>
                            </div>
                            <div className="py-0.5">
                                <a href={`mailto:${contactPage.email}`} className="text-black hover:text-[#1e5a96] transition">
                                    {contactPage.email}
                                </a>
                            </div>
                        </div>
                    </div>

                    {/* Copyright */}
                    <p className="text-[#2d2d2d] font-bold text-center">
                        © {new Date().getFullYear()} ESAM İstanbul | Tüm Hakları Saklıdır
                    </p>

                </div>
            </div>

            {/* Mobile Footer */}
            <div className="md:hidden px-6 py-6">
                {/* Logo */}
                <div className="flex justify-center pb-6">
                    <Link to="/">
                        <img
                            src="/esam-logo.png"
                            alt="ESAM Logo"
                            className="h-10 w-auto object-contain"
                        />
                    </Link>
                </div>

                {/* Accordion Sections */}
                <div className="space-y-3">
                    {/* Kurumsal */}
                    <div className="border-b border-gray-200">
                        <button
                            onClick={() => toggleSection('kurumsal')}
                            className="w-full flex justify-between items-center py-3 text-[#1e5a96] font-bold"
                        >
                            <span>Kurumsal</span>
                            <span className="text-sm">{openSection === 'kurumsal' ? '▲' : '▼'}</span>
                        </button>
                        {openSection === 'kurumsal' && (
                            <div className="pb-3 space-y-2 pl-4">
                                <Link to="kurumsal/kurumsal-kimlik-rehberi" className="block text-gray-700 text-sm">
                                    Kurumsal Kimlik
                                </Link>
                                <Link to="kurumsal/misyon-vizyon" className="block text-gray-700 text-sm">
                                    Misyon & Vizyon
                                </Link>
                                <Link to="kurumsal/baskan" className="block text-gray-700 text-sm">
                                    Başkan
                                </Link>
                                <Link to="kurumsal/yonetim-kurulu" className="block text-gray-700 text-sm">
                                    Yönetim Kurulu
                                </Link>
                            </div>
                        )}
                    </div>

                    {/* Basın */}
                    <div className="border-b border-gray-200">
                        <button
                            onClick={() => toggleSection('basin')}
                            className="w-full flex justify-between items-center py-3 text-[#1e5a96] font-bold"
                        >
                            <span>Basın</span>
                            <span className="text-sm">{openSection === 'basin' ? '▲' : '▼'}</span>
                        </button>
                        {openSection === 'basin' && (
                            <div className="pb-3 space-y-2 pl-4">
                                <Link to="basin/haberler" className="block text-gray-700 text-sm">
                                    Duyurular & Haberler
                                </Link>
                                <Link to="basin/yayinlar" className="block text-gray-700 text-sm">
                                    Yayınlar
                                </Link>
                                <Link to="basin/dergiler" className="block text-gray-700 text-sm">
                                    Dergiler
                                </Link>
                            </div>
                        )}
                    </div>
                    {/* Direktörlüklerimiz */}
                    {directorates?.length > 0 && (
                        <div className="border-b border-gray-200">
                            <button
                                onClick={() => toggleSection('direktor')}
                                className="w-full flex justify-between items-center py-3 text-[#1e5a96] font-bold"
                            >
                                <span>Direktörlüklerimiz</span>
                                <span className="text-sm">
                                    {openSection === 'direktor' ? '▲' : '▼'}
                                </span>
                            </button>

                            {openSection === 'direktor' && (
                                <div className="pb-3 space-y-2 pl-4">
                                    {directorates.slice(0, 6).map((item) => (
                                        <Link
                                            key={item.documentId}
                                            to={`/direktorlukler/${item.slug}`}
                                            className="block text-gray-700 text-sm"
                                        >
                                            {item.displayTitle}
                                        </Link>
                                    ))}
                                </div>
                            )}
                        </div>
                    )}

                    {/* Symposiums */}
                    {symposium?.length > 0 && (
                        <div className="border-b border-gray-200">
                            <button
                                onClick={() => toggleSection('sempozyumlar')}
                                className="w-full flex justify-between items-center py-3 text-[#1e5a96] font-bold"
                            >
                                <span>Sempozyumlar</span>
                                <span className="text-sm">
                                    {openSection === 'sempozyumlar' ? '▲' : '▼'}
                                </span>
                            </button>

                            {openSection === 'sempozyumlar' && (
                                <div className="pb-3 space-y-2 pl-4">
                                    {symposium.slice(0, 6).map((item) => (
                                        <Link
                                            key={item.documentId}
                                            to={`/sempozyumlar/${item.slug}`}
                                            className="block text-gray-700 text-sm"
                                        >
                                            {item.displayTitle}
                                        </Link>
                                    ))}
                                </div>
                            )}
                        </div>
                    )}

                    {/* Bize Ulaşın */}
                    <div className="border-b border-gray-200">
                        <button
                            onClick={() => toggleSection('contact')}
                            className="w-full flex justify-between items-center py-3 text-[#1e5a96] font-bold"
                        >
                            <span>Bize Ulaşın</span>
                            <span className="text-sm">{openSection === 'contact' ? '▲' : '▼'}</span>
                        </button>
                        {openSection === 'contact' && (
                            <div className="pb-3 space-y-2 pl-4">
                                <a href="tel:+902125149586" className="block text-gray-700 text-sm">
                                    +90 212 514 95 86
                                </a>
                                <a href="mailto:istanbul@esam.org.tr" className="block text-gray-700 text-sm">
                                    istanbul@esam.org.tr
                                </a>
                            </div>
                        )}
                    </div>
                </div>

                {/* Social Icons */}
                <div className="flex justify-center py-6">
                    <SocialIcons />
                </div>
                {/* Copyright */}
                <p className="text-[#2d2d2d] font-bold text-center text-sm pt-4">
                    © {new Date().getFullYear()} ESAM İstanbul | Tüm Hakları Saklıdır
                </p>

            </div>
        </footer>
    );
};

export default Layout;